import { render, staticRenderFns } from "./ChatAtPost.vue?vue&type=template&id=90a92156&scoped=true&"
import script from "./ChatAtPost.vue?vue&type=script&lang=js&"
export * from "./ChatAtPost.vue?vue&type=script&lang=js&"
import style0 from "./ChatAtPost.vue?vue&type=style&index=0&id=90a92156&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a92156",
  null
  
)

export default component.exports